export default __webpack_public_path__ + "static/media/admin_panel.c5f2c8de.svg";